exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.link-url[data-v-dfc3f178]{\n    text-decoration: underline;\n    color: #007bff;\n}\n.link-url[data-v-dfc3f178]:link, .link-url[data-v-dfc3f178]:visited, .link-url[data-v-dfc3f178]:hover, .link-url[data-v-dfc3f178]:active {\n  color: blue;\n  cursor : pointer;\n}\n", ""]);

// exports
